module.exports = __webpack_public_path__ + "img/breathing-fair.491f631c.svg";